import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";


export const AD_ENTITY_SERVICE_PROVIDERS = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ad.Country', {route: '/ad/countries'}],
            ['ad.Address', {route: '/ad/addresses'}],
            ['ad.AddressType', {route: '/ad/addressTypes'}],
            ['ad.AddressTypeObjectType', {route: '/ad/addressTypeObjectTypes'}]
        ] as EntityServiceEntry[],
        multi: true
    }
];
